export default "__VITE_ASSET__DE50Ty$f__"